import { render, staticRenderFns } from "./course-create.vue?vue&type=template&id=63d67a38&"
import script from "./course-create.vue?vue&type=script&lang=js&"
export * from "./course-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports